import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import enIN from './locales/en-IN.json';
import es from './locales/es.json';
import te from './locales/te.json';
import hi from './locales/hi.json';
import { detectUserLanguageWithLocation } from '../utils/languageUtils';

// Initialize i18n with enhanced language detection
const initializeI18n = async () => {
  const detectedLanguage = await detectUserLanguageWithLocation();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
      'en-IN': { translation: enIN },
    es: { translation: es },
    te: { translation: te },
    hi: { translation: hi },
  },
    lng: detectedLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});
};

// Initialize immediately
initializeI18n();

export default i18n;
